// vue components
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
Fancybox.Plugins.Toolbar.defaults.items.close.html = "<span></span>";

import ContentSlider from './vue/components/_content-slider.vue';
Vue.component('content-slider', ContentSlider);